import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, Subscriber } from 'rxjs';

import * as Models from 'appshared/shared-models';
import { ProductsService } from './products.service';

// this thing (a resolve) will run before a route is routed
// basically, grab the items from the service

@Injectable({ providedIn: 'root' })
export class ProductsResolverService implements Resolve<Models.Product[]> {
	constructor(private objService: ProductsService) { }

	resolve(): Observable<Models.Product[]> | Observable<never> | Models.Product[] {
		// check to see if the items have ever been loaded.  If not, load'em
		if (this.objService.loaded) {
			// console.log('in resolver - the list is alive!');
			return this.objService.getAll();
		} else {
			// console.log('in resolver - need a new list');
			return new Observable((observe: Subscriber<Models.Product[]>) => {
				this.objService.refreshAll().subscribe((items: Models.Product[]) => {
					observe.next(items);
					observe.complete();
				});
			});
		}
	}
}

// import { Injectable } from '@angular/core';
// import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

// import * as Models from 'appshared/models/shared';
// import { ProductsService } from './products.service';

// // this thing (a resolve) will run before a route is routed
// // basically, grab the objects from the data service if empty

// @Injectable({ providedIn: 'root' })
// export class ProductsResolverService implements Resolve<Models.Product[]> {
// 	constructor(private objService: ProductsService) {}

// 	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
// 		const objects = this.objService.getAll();

// 		if (! objects || objects.length === 0) {
// 			return this.objService.fetchFromDB();
// 		} else {
// 			return objects;
// 		}
// 	}
// }
